import { render, staticRenderFns } from "./form-contatti-businness.vue?vue&type=template&id=a51e919c&"
import script from "./form-contatti-businness.vue?vue&type=script&lang=js&"
export * from "./form-contatti-businness.vue?vue&type=script&lang=js&"
import style0 from "./form-contatti-businness.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports